import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Icon, IconButton, Stack, Typography } from '@emburse/embark-core';
import { EditIcon } from '@emburse/embark-icons';
import { $t } from '../../../hooks/useTranslation';
export function renderStatusCell(params) {
    const { row } = params;
    return (_jsx(Chip, { sx: { height: '25px', width: '50px' }, variant: "outlined", label: row.IsCompanyActive ? $t('ON') : $t('OFF'), color: row.IsCompanyActive ? 'success' : 'monochrome', "data-qa": "status-chip" }));
}
export function renderRuleCell(params) {
    const { row } = params;
    return (_jsx(Typography, { variant: "body2", color: row.IsCompanyActive ? 'inherit' : 'textSecondary', noWrap: true, "data-qa": "rule-cell", children: row.Name }));
}
export function renderParametersCell(params, onEdit) {
    const { row } = params;
    const auditDefParams = row.Params.map((param) => {
        if (param.Alias === 'maxpct') {
            return `${param.Data ? param.Data : param.DefaultValue}%`;
        }
        if (param.Alias === 'maxamtcurr') {
            return `${param.Data ? param.Data : 'USD'}`;
        }
        return param.Data ? param.Data : param.DefaultValue;
    });
    return (_jsxs(Stack, { direction: "row", justifyContent: "space-between", sx: { width: '100%' }, children: [_jsx(Typography, { variant: "body2", color: row.IsCompanyActive ? 'inherit' : 'textSecondary', noWrap: true, "data-qa": "parameters-cell", children: auditDefParams.length ? auditDefParams.join(' ') : 'N/A' }), _jsx(IconButton, { onClick: () => onEdit(params.row), "data-qa": "edit-button", children: _jsx(Icon, { iconUrl: EditIcon }) })] }));
}
export function renderEditCell(params, onEdit) {
    return (_jsx(Stack, { direction: "row", justifyContent: "flex-end", sx: { width: '100%' }, children: _jsx(IconButton, { onClick: () => onEdit(params.row), "data-qa": "edit-button", children: _jsx(Icon, { iconUrl: EditIcon }) }) }));
}
